import { Column, Typography } from '@viewup/ui';
import { privacyServiceData } from './PrivacyService.const';

export const PrivacyService = () => {
  return (
    <Column gap={40}>
      {privacyServiceData.map((data, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <간단한 이용약관에 대한 리스트이기 때문에 인덱스 사용>
        <Column gap={16} key={index}>
          <Typography color='text.assistance' fontType='body2.regular'>
            {data.title}
          </Typography>
          <Typography color='text.assistance' fontType='body2.regular'>
            {data.content}
          </Typography>
        </Column>
      ))}
    </Column>
  );
};
